import { render, staticRenderFns } from "./RedirectComponent.vue?vue&type=template&id=ed8e4e3e"
import script from "./RedirectComponent.vue?vue&type=script&lang=js"
export * from "./RedirectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports